export default "__VITE_ASSET__28b8b897__"